import React from "react";

const Payment = () => {
  return (
    <div>
      <h1 className="text-center text-3xl text-accent mt-10">
        Pay with Stripe
      </h1>
    </div>
  );
};

export default Payment;
